var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftPagination = function SvgArrowLeftPagination(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    fill: "currentColor",
    viewBox: "0 0 8 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.025.52a.75.75 0 0 1 0 1.06L2.557 6.048l4.468 4.469a.75.75 0 0 1-1.06 1.06l-5-4.998a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeftPagination;